import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { CORE_ROUTES, NAVIGATION_ROUTES } from 'src/app/modules/shared/constants/route-paths';

/**
 * Blocks access to a route when the user is previewing as a realtor.
 * Service Requests and other customer-only pages should not be accessible in realtor preview mode.
 */
export const nonRealtorPreviewGuard: CanMatchFn = () => {
	const router = inject(Router);
	const previewRealtorBase = `/${CORE_ROUTES.Preview}/${NAVIGATION_ROUTES.Realtor}/`;
	const nav = router.currentNavigation();
	const targetUrl = nav?.finalUrl ? router.serializeUrl(nav.finalUrl) : router.url;
	return !targetUrl.startsWith(previewRealtorBase);
};